/**
 * Created by mohameds on 22/7/19.
 */
import React from 'react';
import Quote from "../../components/agencyMonitor/Quote";
import {MonitorPageHOC} from '../../components/agencyMonitor/MonitorPageHOC'

class QuoteContainer extends React.PureComponent {
  render =() => (
      <Quote {...this.props} />
  );
}

export default MonitorPageHOC(QuoteContainer);


// WEBPACK FOOTER //
// ./src/containers/AgencyMonitor/QuoteContainer.js